module.exports = __webpack_public_path__ + "static/media/img-2.a0a6f224.jpg";